import moment from 'moment';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { packagesYearBackDetails, productYearBackDetails  } from '../../store/actions/incoming';
import PropTypes from 'prop-types';

const PackageCard = (props) => {
    const navigate = useNavigate();
    const { data, dispatch, index } = props;
    const handleNavigateDate = (date) => {
        if (props.type) {
            dispatch(productYearBackDetails(index));
            navigate(`/incoming-products/product-details`, {
                state: {
                    date,
                },
            });
        } else {
            dispatch(packagesYearBackDetails(index));
            navigate(`/incoming-packages/package-details`, {
                state: {
                    date,
                },
            });
        }

    };
    return (
        <button className='packageCard sortBtn' onClick={() => handleNavigateDate(data.date)}>
            <div className='dateBox'>
                <div className='date'>{moment(data.date).format('MM-DD-YYYY')}</div>
                <div>Date</div>
            </div>
            <div className='packageBox'>
                <div className='totalPackages'>{data.count}</div>
                <div className='Packages'>{props.type ? "Products" : "Packages"}</div>
            </div>
        </button>
    );
}

PackageCard.propTypes = {
    data: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    type: PropTypes.bool.isRequired,
};

export default PackageCard;